import { Breadcrumbs } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import type React from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { PATH as STAFFS_PATH } from "~/pages/settings/staffs";
import SettingStyles from "../../../SettingStyle.module.scss";
import { FormInputPage } from "../FormInputPage";

export const Page: React.FC = () => (
	<DefaultV2>
		<ClientSettingLayout>
			<div className={SettingStyles.BreadcrumbsBlock}>
				<Breadcrumbs
					items={[
						{ as: Link, href: STAFFS_PATH, label: "担当者一覧" },
						{ label: "担当者追加" }
					]}
				/>
			</div>
			<h2 className={SettingStyles.SettingTitle}>担当者追加</h2>
			<FormInputPage />
		</ClientSettingLayout>
	</DefaultV2>
);
